import UserService from "../services/User.Service";
import DocumentService from "../services/Document.Service";
import QuizService from "../services/Quiz.Service";
import DeclarationsService from "../services/Declarations.Service";
import CompaniesService from "../services/Company.Service";
// import QuizQuestionService from "../services/Quiz.Questions.Service";
import Auth from "../services/Auth.Service";
import Company from "../services/Company.Service";
import Modules from "../services/Modules.Service";
import AlertsService from "../services/Alert.Service";
import TaxInvoiceService from "../services/TaxInvoice.Service";
import Tool from "../services/Tool.Service";
import QuizAnswersService from "../services/QuizAnswers.Service";
import ProjectsService from "../services/Projects.Service";
import ProjectHoursService from '../services/ProjectHours.Service';
import ProjectUsersService from "../services/ProjectUsers.Service";
import ContractService from "../services/Contract.Service";
import ContractPatternService from "../services/ContractPattern.Service";
import PaymentScheduleService from "../services/PaymentSchedule.Service";
import ContractValueInputService from "../services/ContractValueInput.Service";
import ApiKeysService from "../services/ApiKeys.Service";
import UserPermissionsService from "../services/UserPermissions.Service";
import TimeClockService from "../services/TimeClock.Service";
import CompanyDayOffService from "../services/CompanyDayOff.Service";
import ConfidentialGroupsService from "../services/ConfidentialGroups.Service";

const allServices = {
	declarations:    () => new DeclarationsService(),
	alerts:          () => new AlertsService(),
	users:           () => new UserService(),
	taxInvoices:   	 () => new TaxInvoiceService(),
	documents:       () => new DocumentService(),
	quiz:            () => new QuizService(),
	quizAnswers:     () => new QuizAnswersService(),
	auth:			 () => new Auth(),
	companies:       () => new Company(),
	modules:         () => new Modules(),
	tools:           () => new Tool(),
	company:         () => new CompaniesService(),
	projects:        () => new ProjectsService(),
	projectHours:	 () => new ProjectHoursService(),
	projectUsers:	 () => new ProjectUsersService(),
	contracts:       () => new ContractService(),
	contractPatterns: () => new ContractPatternService(),
	'payment-schedules': () => new PaymentScheduleService(),
	'contract-value-inputs': () => new ContractValueInputService(),
	apiKeys:         () => new ApiKeysService(),
	userPermissions: () => new UserPermissionsService(),
	timeClock:       () => new TimeClockService(),
	companyDayOffs:  () => new CompanyDayOffService(),
	confidentialGroups: () => new ConfidentialGroupsService(),
};

const useService = (service) => {
    if (allServices[service]) {
        return allServices[service]();
    }

    return null;
};

export default useService;
